export { default as CoreConfigHtmlDirective } from './Html';
